import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appZip]',
  standalone: true
})
export class ZipDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
    private control: NgControl
  ) {}

  @HostListener('input')
  @HostListener('paste')
  @HostListener('blur')
  onInput() {
    setTimeout(() => this.formatAndValidate(), 0);
  }

  private formatAndValidate() {
    const input = this.el.nativeElement;
    let value = input.value || '';
    let cleaned = value.replace(/[^\d-]/g, '');
    let digits = cleaned.replace(/-/g, '');

    if (digits.length > 9) {
      digits = digits.substring(0, 9);
      cleaned = cleaned.substring(0, 10);
    }

    let formatted = '';

    if (digits.length === 5) {
      formatted = digits; 
    }
    else if (digits.length === 9) {
      if (cleaned.length === 10 && cleaned[5] === '-') {
        formatted = cleaned;
      } else {
        formatted = digits.substring(0, 5) + '-' + digits.substring(5);
      }
    }
    else {
      formatted = cleaned;
    }

    if (input.value !== formatted) {
      this.renderer.setProperty(input, 'value', formatted);
      this.control.control?.setValue(formatted, { emitEvent: false });
    }
    this.control.control?.markAsTouched();
    this.control.control?.markAsDirty();
    this.control.control?.updateValueAndValidity();
  }
}